<script lang="ts">
  import { page } from '$app/state';

  import { Expandable } from '@agapi/ui/expandable';
  import { Button } from '@agapi/ui/button';
  import { childCollectionsStyles } from './child-collections.styles';
  import { css } from '@agapi/ui/panda/css';
  import { CaretLeft } from 'phosphor-svelte';
  import { stack } from '@agapi/ui/panda/patterns';

  import * as m from '$lib/parachute/messages';
  import { rewriteUrl } from '../../../utils';

  interface ChildCollection {
    name: string;
    path: string;
  }
//TODO: Remove forceBlueColor when we have a more scalable solution
  const { childCollections, isBigger, parent, forceBlueColor }: { childCollections: ChildCollection[], isBigger: boolean, forceBlueColor?: boolean, parent?: {name: string, path: string} } = $props();

  const classes = childCollectionsStyles.raw();
</script>

<div class={stack({gap: '0'})}>
{#if parent}
<Button as="a" href={rewriteUrl(page, parent.path)} size={isBigger ? 'md' : 'sm'} css={{...classes.childCollectionButton, mr: 'auto',}}>
  <CaretLeft/>
  {parent.name}
</Button>
{/if}
{#if childCollections?.length > 0}
  <Expandable showLabel={m.showAll({value: isBigger ? m.campaign() : m.subcategories()})} hideLabel={m.hide()} initialHeight={140}>
    <div class={css(classes.childCollections)} style:grid-template-columns={isBigger ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'}>
      {#each childCollections as category}
        <Button as="a" href={rewriteUrl(page, category.path)} size={isBigger ? 'md' : 'sm'} css={forceBlueColor ? classes.childCollectionButtonBlue : classes.childCollectionButton}>
          {category.name}
        </Button>
      {/each}
    </div>
  </Expandable>
{/if}
</div>
